import React from 'react';

const AgentTrends: React.FC = () => (
  <div className="max-w-7xl mx-auto px-4 py-8">
    <h1 className="text-2xl font-bold mb-6">Trend Reports</h1>
    <p className="text-gray-600">Predictive analytics and rising talent insights.</p>
  </div>
);

export default AgentTrends;
